"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenShareKnockItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ScreenShareKnockItem = require("./ScreenShareKnockItem.styled");
var _KnockItemFooter = _interopRequireDefault(require("../KnockItemFooter/KnockItemFooter"));
var _KnockItemHeader = _interopRequireDefault(require("../KnockItemHeader/KnockItemHeader"));
var _excluded = ["type", "name"];
var ScreenShareKnockItem = exports.ScreenShareKnockItem = function ScreenShareKnockItem(_ref) {
  var type = _ref.type,
    name = _ref.name,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_ScreenShareKnockItem.ScreenShareKnockItemContainer, null, /*#__PURE__*/_react["default"].createElement(_KnockItemHeader["default"], {
    type: type,
    presenterName: name,
    captitalizeTitle: false
  }), /*#__PURE__*/_react["default"].createElement(_KnockItemFooter["default"], (0, _extends2["default"])({
    type: type,
    presenterName: name
  }, props)));
};
ScreenShareKnockItem.propTypes = {
  _id: _propTypes["default"].string,
  type: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  sources: _propTypes["default"].array,
  onApprove: _propTypes["default"].func.isRequired,
  onDeny: _propTypes["default"].func.isRequired,
  onAssignKnockToSource: _propTypes["default"].func
};